import { DeleteDriver } from "./DeleteDriver";
import { EditDriver } from "./EditDriver";

export const DriverModal = {
  Delete: DeleteDriver,
  Edit: EditDriver
};
